import BaseService from './BaseService'

class SessionService extends BaseService {
  constructor() {
    super('/session')
  }

  // Location session management methods
  async getCurrentLocationFromSession() {
    return this.customRequest('get', '/location', null, { meta: { silent: true } })
  }

  async setCurrentLocationInSession(locationId) {
    return this.customRequest('post', '/location', { location_id: locationId })
  }

  async getAccessibleLocations() {
    return this.customRequest('get', '/locations', null, { meta: { silent: true } })
  }
}

export const sessionService = new SessionService()
